import React, { useEffect, useState } from 'react';
import { Typography, Input, Row, Col, Button, Space, message } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import {useParams} from 'react-router-dom';
import { Section } from '../../components/UI/Section.component';
import { EditInformationForm } from '../../components/Dashboard/Client/EditInformationForm';
import ClientService from '../../services/client.service';
const { Title } = Typography;

export const EditClientAccountScreen = () => {

    const params = useParams();
    const [client, setClient] = useState({})
    const [branches, setBranches] = useState({})
    const [isLoaded, setIsLoaded] = useState(false)
    
    useEffect(() => {
        let data =  {id: params.id};
        ClientService.getClient(data).then(
          (response) => {
            setClient(response.data.client);
            setBranches(response.data.branches);
            console.log(client)
            setIsLoaded(true);
          },
          (error) => {
              // console.log(error.response.data.message)
          }
        );
    }, [])


    return(
        <>
            <Screen id="">
                <Container >
                    <Section style={{width: '600px'}}>
                        <Row justify="space-between " style={{gap:"10px",}}>
                            <Col>
                                { isLoaded && <EditInformationForm client={client} branches={branches} clientID={params.id} />}
                            </Col>
                        </Row>
                    </Section>
                </Container>
            </Screen>
        </>
    )
}
